'use client';

import { c as _c } from "react/compiler-runtime";
import { useMediaPlayer } from '@/context/MediaContext';
import MediaPlayer from '../MediaPlayer';
import { VidstackAudioPlayer, VidstackVideoPlayer } from '../players';
import { useParams } from 'next/navigation';
const MediaController = () => {
  const $ = _c(43);
  const {
    lang
  } = useParams();
  const {
    state,
    actions,
    selectors
  } = useMediaPlayer();
  const {
    isPlaying
  } = selectors;
  if (!state.isVisible || !state.currentMedia) {
    return null;
  }
  let t0;
  if ($[0] !== actions) {
    t0 = () => {
      actions.setPlaybackState("paused");
      actions.closePlayer();
    };
    $[0] = actions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleMediaFrameClose = t0;
  let t1;
  if ($[2] !== actions) {
    t1 = (currentTime, duration) => {
      actions.updatePosition({
        currentTime,
        duration
      });
    };
    $[2] = actions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleTimeUpdate = t1;
  let t2;
  if ($[4] !== actions) {
    t2 = error => {
      const errorMessage = error instanceof Error ? error.message : "Unknown media error";
      actions.setError(errorMessage);
    };
    $[4] = actions;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleError = t2;
  let t3;
  if ($[6] !== actions) {
    t3 = () => {
      actions.setPlaybackState("playing");
    };
    $[6] = actions;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handlePlay = t3;
  let t4;
  if ($[8] !== actions) {
    t4 = () => {
      actions.setPlaybackState("paused");
    };
    $[8] = actions;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handlePause = t4;
  let t5;
  if ($[10] !== actions || $[11] !== state.volume.isMuted) {
    t5 = (volume, muted) => {
      if (muted !== state.volume.isMuted) {
        actions.toggleMute();
      } else {
        actions.setVolume(volume);
      }
    };
    $[10] = actions;
    $[11] = state.volume.isMuted;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleVolumeChange = t5;
  let t6;
  if ($[13] !== actions) {
    t6 = time => {
      actions.seekTo(time);
    };
    $[13] = actions;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleSeek = t6;
  const handleLoaded = _temp;
  let t7;
  if ($[15] !== actions) {
    t7 = () => {
      actions.setPlaybackState("loading");
    };
    $[15] = actions;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const handleLoadStart = t7;
  let t8;
  if ($[17] !== handleError || $[18] !== handleLoadStart || $[19] !== handlePause || $[20] !== handlePlay || $[21] !== handleSeek || $[22] !== handleTimeUpdate || $[23] !== handleVolumeChange || $[24] !== isPlaying || $[25] !== state.currentMedia || $[26] !== state.metadata || $[27] !== state.playbackRate || $[28] !== state.volume.isMuted || $[29] !== state.volume.level) {
    t8 = () => {
      if (!state.currentMedia) {
        return null;
      }
      if (state.metadata?.type === "video") {
        return <VidstackVideoPlayer source={state.currentMedia} poster={state.metadata?.cover} volume={state.volume.level} playbackRate={state.playbackRate} muted={state.volume.isMuted} isPlaying={isPlaying} onPlay={handlePlay} onPause={handlePause} onSeekRequest={handleSeek} onTimeUpdate={handleTimeUpdate} onVolumeChange={handleVolumeChange} onError={handleError} onLoaded={handleLoaded} onLoadStart={handleLoadStart} />;
      }
      return <VidstackAudioPlayer source={state.currentMedia} metadata={state.metadata} poster={state.metadata?.cover} volume={state.volume.level} muted={state.volume.isMuted} isPlaying={isPlaying} onPlay={handlePlay} onPause={handlePause} onSeekRequest={handleSeek} onTimeUpdate={handleTimeUpdate} onVolumeChange={handleVolumeChange} onError={handleError} onLoaded={handleLoaded} onLoadStart={handleLoadStart} />;
    };
    $[17] = handleError;
    $[18] = handleLoadStart;
    $[19] = handlePause;
    $[20] = handlePlay;
    $[21] = handleSeek;
    $[22] = handleTimeUpdate;
    $[23] = handleVolumeChange;
    $[24] = isPlaying;
    $[25] = state.currentMedia;
    $[26] = state.metadata;
    $[27] = state.playbackRate;
    $[28] = state.volume.isMuted;
    $[29] = state.volume.level;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  const player = t8;
  const t9 = state.isVisible;
  const t10 = state.metadata?.title || "Media Player";
  const t11 = state.metadata?.type || "video";
  const t12 = lang === "fa" ? "bottom-left" : "bottom-right";
  let t13;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      width: "100%",
      height: "100%"
    };
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== player) {
    t14 = player();
    $[32] = player;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14) {
    t15 = <div style={t13}>{t14}</div>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== handleMediaFrameClose || $[37] !== state.isVisible || $[38] !== t10 || $[39] !== t11 || $[40] !== t12 || $[41] !== t15) {
    t16 = <MediaPlayer isVisible={t9} title={t10} mediaVariant={t11} initialPosition={t12} onClose={handleMediaFrameClose}>{t15}</MediaPlayer>;
    $[36] = handleMediaFrameClose;
    $[37] = state.isVisible;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
};
export default MediaController;
function _temp() {}